import React, { useState, useEffect } from "react";
import { Button, Container, Typography, Card, CardContent, Stack } from "@mui/material";
import { FeedbackFormComponent } from "components/feedback/FeedbackFormComponent"
import useFeedbacks from "model/feedback/FeedbackStore"
import { create } from "access/FeedbackService"
import localAuth from 'model/auth/AuthStore';
import { Turnstile } from '@marsidev/react-turnstile';
import { REACT_APP_CAPTCHA } from "utils/Common";
import TopAlert from 'components/common/TopAlert';
import { useAuth0 } from "@auth0/auth0-react";

/**
 * TODO: https://dash.cloudflare.com/sign-up?to=/:account/turnstile
 * @returns 
 */
const ContactForm: React.FC = () => {
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [token, setToken] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const { user, isAuthenticated } = useAuth0();

  const visited = useFeedbacks((state) => state.visited);
  const violations = useFeedbacks((state) => state.violations);
  const feedback = useFeedbacks((state) => state.feedback);
  const updateFeedback = useFeedbacks((state) => state.updateFeedback);
  const accessToken: string = localAuth((state) => state.authToken);
  
  useEffect(() => {
    if (isAuthenticated && user?.sub) {
      updateFeedback('userId', user.sub);
    }
  }, [isAuthenticated, user, updateFeedback]);
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    
    if (!token) {
      return;
    }

    setLoading(true);
    try {
      await create(feedback, accessToken);
      setSubmitted(true);
    } catch (err) {
      console.error("Failed to submit feedback", err);
      setErrorMessage("Oops there was an error, please try again later");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <TopAlert message={errorMessage} severity="error" setMessage={setErrorMessage} />
      <Card variant='outlined'>
        <CardContent>
          <Typography variant="h5" gutterBottom>Contact Us</Typography>
          <Typography className='wizard-subtitle-color'>
          Whether you're experiencing an issue, have a suggestion for improvement, or just want 
          to say hello, feel free to reach out. Your feedback is invaluable in helping us improve our 
          service!
          </Typography>
          <br/>
          {submitted ? (
            <Typography variant="h6">
              Thank you for reaching out! We will get back to you soon.
            </Typography>
          ) : (
            <>
              <FeedbackFormComponent />
              <Turnstile
                siteKey={REACT_APP_CAPTCHA}
                onSuccess={(token) => setToken(token)}
                onError={() => console.log('Turnstile error')}
                onExpire={() => setToken('')}
                options={
                  { 
                    theme: 'auto',
                    size: 'normal'
                  }
                }
              />
              <Button sx={{ marginTop: 4 }}
                disabled={(violations.size > 0 || visited.size < 3) || token === '' || loading} 
                      onClick={(e) => handleSubmit(e)} 
                      variant="contained" 
                      color="primary">
                {loading ? "Sending..." : "Send"}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default ContactForm;
